import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useAssignSettingSelfServeBrandInstantAnswers, useSettingSelfServeBrandInstantAnswers } from "@faire/help-center-utils/settings/useSettingSelfServiceBrandInstantAnswers";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Clipboard } from "@faire/web--source/slate/icons/foundation/Clipboard";
import React from "react";
export var useMyCatalogBrandNodes = function useMyCatalogBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var enableSettingSelfServeBrandInstantAnswers = useSettingSelfServeBrandInstantAnswers();
  var assignSettingSelfServeBrandInstantAnswers = useAssignSettingSelfServeBrandInstantAnswers();
  var articles = useArticles();
  var commonFields = {
    id: "MyCatalog",
    label: strictLocalize({
      id: "FjWrdn",
      defaultMessage: [{
        "type": 0,
        "value": "Productcatalogus"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Clipboard, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    articles: [articles.ManageMyShop.CUSTOMIZE_MY_PRODUCT_TRANSLATIONS, articles.ManageMyShop.CURRENCY_SPECIFIC_PRICING, articles.ManageMyShop.SETTING_PRODUCT_INVENTORY_LEVELS, articles.ManageMyShop.ARRANGE_MY_SHOP_LISTINGS],
    level: 1,
    assignSetting: assignSettingSelfServeBrandInstantAnswers,
    sidebarTitle: strictLocalize({
      id: "BRiEk3",
      defaultMessage: [{
        "type": 0,
        "value": "Catalogusprobleem"
      }]
    })
  };
  if (!enableSettingSelfServeBrandInstantAnswers) {
    return {
      MyCatalog: _objectSpread({}, commonFields)
    };
  }
  return {
    MyCatalog: _objectSpread(_objectSpread({}, commonFields), {}, {
      children: ["AllProducts", "GetFaireToHelpAddProducts", "EditProducts", "ListingSettings", "InternationalPricing"],
      shouldStopAddingDefaultOtherNodeToChildren: true
    }),
    AllProducts: {
      id: "AllProducts",
      label: strictLocalize({
        id: "OhtjQP",
        defaultMessage: [{
          "type": 0,
          "value": "Alle producten"
        }]
      }),
      children: ["AddSingleProduct", "AddMultipleProducts", "ImportProductsWithIntegrations", "AllowedAndRestrictedProducts"],
      level: 2
    },
    GetFaireToHelpAddProducts: {
      id: "GetFaireToHelpAddProducts",
      label: strictLocalize({
        id: "2bh4oR",
        defaultMessage: [{
          "type": 0,
          "value": "Vraag Faire om te helpen producten toe te voegen"
        }]
      }),
      level: 2
    },
    EditProducts: {
      id: "EditProducts",
      label: strictLocalize({
        id: "0dI8Xj",
        defaultMessage: [{
          "type": 0,
          "value": "Producten bewerken"
        }]
      }),
      children: ["EditSingleProduct", "EditMultipleProducts", "ManageProductImages"],
      level: 2
    },
    ListingSettings: {
      id: "ListingSettings",
      label: strictLocalize({
        id: "hkU+K/",
        defaultMessage: [{
          "type": 0,
          "value": "Instellingen voor productpagina’s"
        }]
      }),
      children: ["Preorders", "OpenSizing", "Prepacks", "TariffCodes", "ProductTranslations", "Samples"],
      level: 2
    },
    InternationalPricing: {
      id: "InternationalPricing",
      label: strictLocalize({
        id: "Ok8AXt",
        defaultMessage: [{
          "type": 0,
          "value": "Internationale prijzen"
        }]
      }),
      level: 2
    },
    AddSingleProduct: {
      id: "AddSingleProduct",
      label: strictLocalize({
        id: "vDAz4R",
        defaultMessage: [{
          "type": 0,
          "value": "Één product toevoegen"
        }]
      }),
      level: 3
    },
    AddMultipleProducts: {
      id: "AddMultipleProducts",
      label: strictLocalize({
        id: "dvjurR",
        defaultMessage: [{
          "type": 0,
          "value": "Voeg meerdere producten toe"
        }]
      }),
      level: 3
    },
    ImportProductsWithIntegrations: {
      id: "ImportProductsWithIntegrations",
      label: strictLocalize({
        id: "ATsDmb",
        defaultMessage: [{
          "type": 0,
          "value": "Producten importeren met integraties"
        }]
      }),
      level: 3
    },
    AllowedAndRestrictedProducts: {
      id: "AllowedAndRestrictedProducts",
      label: strictLocalize({
        id: "cxfjO5",
        defaultMessage: [{
          "type": 0,
          "value": "Toegestane en verboden producten"
        }]
      }),
      level: 3
    },
    EditSingleProduct: {
      id: "EditSingleProduct",
      label: strictLocalize({
        id: "WvswQm",
        defaultMessage: [{
          "type": 0,
          "value": "Eén product bewerken"
        }]
      }),
      level: 3
    },
    EditMultipleProducts: {
      id: "EditMultipleProducts",
      label: strictLocalize({
        id: "eGOOCM",
        defaultMessage: [{
          "type": 0,
          "value": "Meerdere producten bewerken"
        }]
      }),
      level: 3
    },
    ManageProductImages: {
      id: "ManageProductImages",
      label: strictLocalize({
        id: "yc775S",
        defaultMessage: [{
          "type": 0,
          "value": "Productafbeeldingen beheren"
        }]
      }),
      level: 3
    },
    Preorders: {
      id: "Preorders",
      label: strictLocalize({
        id: "cPHH95",
        defaultMessage: [{
          "type": 0,
          "value": "Voorbestellingen"
        }]
      }),
      level: 3
    },
    OpenSizing: {
      id: "OpenSizing",
      label: strictLocalize({
        id: "h/I5gl",
        defaultMessage: [{
          "type": 0,
          "value": "Flexibele maatvoering "
        }]
      }),
      level: 3
    },
    Prepacks: {
      id: "Prepacks",
      label: strictLocalize({
        id: "U/5/j5",
        defaultMessage: [{
          "type": 0,
          "value": "Prepacks"
        }]
      }),
      level: 3
    },
    TariffCodes: {
      id: "TariffCodes",
      label: strictLocalize({
        id: "FPDHFA",
        defaultMessage: [{
          "type": 0,
          "value": "Tariefcodes"
        }]
      }),
      level: 3
    },
    ProductTranslations: {
      id: "ProductTranslations",
      label: strictLocalize({
        id: "HhB7V5",
        defaultMessage: [{
          "type": 0,
          "value": "Productvertalingen"
        }]
      }),
      level: 3
    },
    Samples: {
      id: "Samples",
      label: strictLocalize({
        id: "wouYyC",
        defaultMessage: [{
          "type": 0,
          "value": "Proefmonsters"
        }]
      }),
      level: 3
    }
  };
};